import React, { memo, useCallback } from 'react';

const LIFECYCLE_MODES = {
  active: 'active',
  churned: 'churned',
};

const Lifecycle = ({ value, onChange }) => {
  const handleOnChange = useCallback(
    (event) => {
      const newMode = event.target.value;
      const obj = {
        mode: newMode,
      };

      onChange(obj);
    },
    [onChange],
  );

  return (
    <div className="subquery">
      <select
        className="form-control"
        value={value.mode}
        onChange={handleOnChange}
      >
        <option value={LIFECYCLE_MODES.active}>Active Customer</option>
        <option value={LIFECYCLE_MODES.churned}>Churned</option>
      </select>
    </div>
  );
};

export default memo(Lifecycle);
